import React from 'react'
import "./../Convenience/ConvenienceStyle.css"


function Convenience() {
  return (
    <div className='main_convenience_div'>
    <div className='convenience_content' >

        <div className='convenience_text' >Close At Your Convenience</div>
        <div className='below_convenience' >Selling your home has never been so easy!</div>
        <div className='convenience_btn' type="button" >Get My Offer Now! </div>
        <div className='call_us' >Or Call Us For FREE <strong className='bold_num'>866-928-4635</strong></div>
    </div>
      
    </div>
  )
}

export default Convenience
